import { isAddress } from 'viem';

// Everything the Fund flow can currently pay out (USDT ERC-20 / ETH) lives on
// an EVM chain. The Transfer view passes the token TICKER as both network and
// key ('USDT' / 'ETH'), which previously matched no rule and fell through to
// "valid" — so any typed text was accepted as a destination wallet.
const EVM_NETWORKS = ['BEP-20', 'ERC-20', 'ETHEREUM'];
const EVM_KEYS = ['USDT', 'ETH', 'ETHEREUM', 'TETHER', 'USDT-ERC20', 'USDT-BEP20'];

function upper(value) {
  return String(value || '')
    .trim()
    .toUpperCase();
}

function isEvmAsset(asset) {
  return EVM_NETWORKS.includes(upper(asset?.network)) || EVM_KEYS.includes(upper(asset?.key));
}

export function validateDestination(asset, address) {
  const value = String(address || '').trim();
  if (!value) return { valid: false, message: '' };

  if (asset?.network === 'TRC-20' || asset?.key === 'trx') {
    if (/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value)) return { valid: true, message: '' };
    return { valid: false, message: 'Enter a valid TRON (TRC-20) address.' };
  }

  if (isEvmAsset(asset)) {
    // Accepts all-lowercase addresses; a mixed-case address must carry a valid
    // EIP-55 checksum, which catches most typos.
    if (isAddress(value)) return { valid: true, message: '' };
    return { valid: false, message: 'Enter a valid EVM (0x…) address.' };
  }

  if (asset?.key === 'btc') {
    if (/^(bc1[0-9a-z]{20,80}|[13][a-km-zA-HJ-NP-Z1-9]{25,39})$/.test(value)) {
      return { valid: true, message: '' };
    }
    return { valid: false, message: 'Enter a valid Bitcoin address.' };
  }

  if (asset?.key === 'sol') {
    if (/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(value)) return { valid: true, message: '' };
    return { valid: false, message: 'Enter a valid Solana address.' };
  }

  // Unknown asset type: refuse rather than send funds somewhere unchecked.
  return { valid: false, message: 'Unsupported asset for manual address entry.' };
}

export function validateSomaliaPhone(local) {
  const digits = String(local || '').replace(/\D/g, '');
  if (digits.length >= 7 && digits.length <= 12) return { valid: true };
  return { valid: false };
}
